/**
 * Formats a price value to a fixed 2-decimal string representation
 * Returns '-' for null, undefined, empty, or invalid numeric values
 * 
 * @param price - The price value to format (number, string, null, or undefined)
 * @returns Formatted price string with 2 decimal places or '-' if invalid
 */
export const formatPrice = (price: number | string | null | undefined): string => {
  if (price === null || price === undefined || price === '') return '-';
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(numPrice)) return '-';
  return numPrice.toFixed(2);
};

/**
 * Formats a price difference value with sign indicator
 * Adds '+' prefix for positive differences, '-' for negative, and returns '-' for zero or invalid values
 * 
 * @param difference - The difference value to format (number, string, null, or undefined)
 * @returns Formatted difference string with sign and 2 decimal places or '-' if invalid
 */
export const formatDifference = (difference: number | string | null | undefined): string => {
  if (difference === null || difference === undefined || difference === '') return '-';
  const numDiff = typeof difference === 'string' ? parseFloat(difference) : difference;
  if (isNaN(numDiff)) return '-';
  const sign = numDiff > 0 ? '+' : '';
  return `${sign}${numDiff.toFixed(2)}`;
};
